import { useMutation } from "@tanstack/react-query";
import {
  CreateProductCategoryFormType,
  CreateProductCategoryResponse,
  CreateProductSubCategoryFormType,
  CreateProductSubCategoryResponse,
  DeleteProductCategoryRequestBody,
  DeleteProductCategoryResponse,
  DeleteProductSubCategoryRequestBody,
  DeleteProductSubCategoryResponse,
  EditProductCategoryFormType,
  EditProductCategoryResponse,
  EditProductSubCategoryFormType,
  EditProductSubCategoryResponse,
} from "./interfaces";

import queryClient from "src/config/reactQuery.config";
import {
  createProductCategory,
  createProductSubCategory,
  deleteProductCategory,
  deleteProductSubCategory,
  editProductCategory,
  editProductSubCategory,
} from "src/services/ProductCategory.service";

export const useCreateProductCategory = () => {
  return useMutation<
    CreateProductCategoryResponse,
    Error,
    CreateProductCategoryFormType
  >({
    mutationFn: (value) => createProductCategory(value),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["product-category"] });
    },
  });
};

export const useEditProductCategory = () => {
  return useMutation<
    EditProductCategoryResponse,
    Error,
    EditProductCategoryFormType
  >({
    mutationFn: (value) => editProductCategory(value),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["product-category"] });
    },
  });
};

export const useDeleteProductCategory = () => {
  return useMutation<
    DeleteProductCategoryResponse,
    Error,
    DeleteProductCategoryRequestBody
  >({
    mutationFn: (value) => deleteProductCategory(value),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["product-category"] });
    },
  });
};

export const useCreateProductSubCategory = () => {
  return useMutation<
    CreateProductSubCategoryResponse,
    Error,
    CreateProductSubCategoryFormType
  >({
    mutationFn: (value) => createProductSubCategory(value),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["product-category"] });
    },
  });
};

export const useEditProductSubCategory = () => {
  return useMutation<
    EditProductSubCategoryResponse,
    Error,
    EditProductSubCategoryFormType
  >({
    mutationFn: (value) => editProductSubCategory(value),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["product-category"] });
    },
  });
};

export const useDeleteProductSubCategory = () => {
  return useMutation<
    DeleteProductSubCategoryResponse,
    Error,
    DeleteProductSubCategoryRequestBody
  >({
    mutationFn: (value) => deleteProductSubCategory(value),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["product-category"] });
    },
  });
};
